import React from 'react'
import {Switch, Route, useRouteMatch} from 'react-router-dom'

import Onboarding from '@progyny/pages/Consultations/Onboarding'

interface ConsultationRoutesProps {
  consultationSlug: string
  assessmentComponent?: React.ComponentType<{
    consultationSlug: string
    basePath: string
  }>
  overviewComponent: React.ComponentType
  onboardingSlugOverride?: string
  /** When provided, adds /upcoming and /past routes (e.g. for Menopause). */
  upcomingPastView?: React.ComponentType<{activeTab: 'upcoming' | 'past'}>
}

const ConsultationRoutes: React.FC<ConsultationRoutesProps> = ({
  consultationSlug,
  assessmentComponent: AssessmentComponent,
  overviewComponent: OverviewComponent,
  onboardingSlugOverride,
  upcomingPastView: UpcomingPastView,
}) => {
  const {path, url} = useRouteMatch()
  const onboardingSlug = onboardingSlugOverride || consultationSlug

  return (
    <Switch>
      {AssessmentComponent && (
        <Route
          path={`${path}/assessment`}
          render={() => (
            <AssessmentComponent
              consultationSlug={consultationSlug}
              basePath={url}
            />
          )}
        />
      )}
      <Route
        path={`${path}/onboarding/:mode?`}
        render={() => (
          <Onboarding
            consultationSlug={onboardingSlug}
            hubConsultationSlug={consultationSlug}
            basePath={url}
          />
        )}
      />
      {UpcomingPastView && (
        <Route
          path={`${path}/upcoming`}
          render={() => <UpcomingPastView activeTab='upcoming' />}
        />
      )}
      {UpcomingPastView && (
        <Route
          path={`${path}/past`}
          render={() => <UpcomingPastView activeTab='past' />}
        />
      )}
      <Route exact path={path} component={OverviewComponent} />
    </Switch>
  )
}

export default ConsultationRoutes
